import {Dialog, IconButton, DialogActions, Divider} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import GlobalVariables from "../models/globalVariables";
import {ButtonAddyPurple} from "./ButtonAddyPurple";

const RequireUpgradeModal = ({open, onClose, uid, organizationID}) => {
  const redirectUrl = uid === undefined || uid === null
    ? `https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ14Yd2sVCVDddl1KA8BaGZ5auD57yLta8DuaK9ev9naVapg6HbBrX4V6klpa2MJhjWWmD41opB2`
    : organizationID === undefined || organizationID === null
      ? `${GlobalVariables.getFrontDomain()}`
      : `${GlobalVariables.getFrontDomain()}/organizations/${organizationID}/edit?folder=billingq`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      sx={{
        borderRadius: "16px",
        backdropFilter: "blur(14px)",
        backgroundColor: "rgba(255, 255, 255, 0.05)",
        padding: "16px",
        "& .MuiDialog-paper": {
          color: "var(--text-tertiary)",
          borderRadius: "16px",
          padding: "16px",
        },
        fontFamily: "Inter"
      }}
    >
      <div className="flex flex-col text-start gap-[32px] p-[15px] mt-[100px] mb-[65px]" style={{padding: "15px !important"}}>
        <IconButton
          aria-label="close"
          onClick={() => {
            onClose();
          }}
          className="absolute top-2 right-2 z-10"
          sx={{
            position: "absolute !important",
            top: "10px",
            right: "10px",
            zIndex: 1000,
          }}
        >
          <CloseIcon />
        </IconButton>
        <h2 className=" text-[20px] font-semibold text-foreground-strong w-[100%]">
          Upgrade to use this feature
        </h2>
        <p className="text-foreground-secondary text-[14px] font-medium">
          Use modern AI technology to scale your business and stay ahead of the
          competition. Book a demo with our team today to get started.
        </p>
      </div>
      <DialogActions 
        sx={{
          padding: 0,
          margin: 0,
          '&.MuiDialogActions-root': {
            padding: 0,
            margin: 0
          }
        }}
      >
        <ButtonAddyPurple
          height={"32px"}
          width={"100%"}
          text={"Book a demo"}
          iconHeight={"15px"}
          iconWidth={"15px"}
          onClickFunction={() => {
            window.open("https://calendar.app.google/U3vBcoNXpkF7WiDFA", "_blank");
          }}
        ></ButtonAddyPurple>
      </DialogActions>
    </Dialog>
  );
};

export default RequireUpgradeModal;
